export const subscriptionTypes = {
  // Membresías del club
  adult: 'Socio',
  youth: 'Socio Joven',
  padel: 'Socio Padel',

  // Escuela de tenis - Socios
  socio_6p_4h: 'Escuela de Tenis - Socio - 6 alumnos - 4h/mes',
  socio_6p_8h: 'Escuela de Tenis - Socio - 6 alumnos - 8h/mes',
  socio_4p_4h: 'Escuela de Tenis - Socio - 4 alumnos - 4h/mes',
  socio_4p_8h: 'Escuela de Tenis - Socio - 4 alumnos - 8h/mes',
  // socio_2p_4h: 'Escuela de Tenis - Socio - 2 alumnos - 4h/mes',
  // socio_2p_8h: 'Escuela de Tenis - Socio - 2 alumnos - 8h/mes',

  // Escuela de tenis - No socios
  no_socio_6p_4h: 'Escuela de Tenis - No Socio - 6 alumnos - 4h/mes',
  no_socio_6p_8h: 'Escuela de Tenis - No Socio - 6 alumnos - 8h/mes',
  no_socio_4p_4h: 'Escuela de Tenis - No Socio - 4 alumnos - 4h/mes',
  no_socio_4p_8h: 'Escuela de Tenis - No Socio - 4 alumnos - 8h/mes',
};
